import { useCallback, useState } from "react";
import type { CreateServiceRequest } from "@/types/api";
import { isValidJson, PubSubFields } from "./PubSubFields";

export function usePubSubFields() {
  const [projectId, setProjectId] = useState("");
  const [accountKeyContent, setAccountKeyContent] = useState("");
  const [subscription, setSubscription] = useState("");

  const toPayload = useCallback((): Partial<CreateServiceRequest> => {
    if (!isValidJson(accountKeyContent)) {
      throw new Error("Service account key is not valid JSON");
    }

    const payload: Partial<CreateServiceRequest> = {
      project_id: projectId,
      auth: {
        kind: "service_account_key",
        account_key_content: accountKeyContent,
      },
    };
    const trimmedSubscription = subscription.trim();
    if (trimmedSubscription) payload.subscription = trimmedSubscription;
    return payload;
  }, [projectId, accountKeyContent, subscription]);

  const fields = (
    <PubSubFields
      projectId={projectId}
      setProjectId={setProjectId}
      accountKeyContent={accountKeyContent}
      setAccountKeyContent={setAccountKeyContent}
      subscription={subscription}
      setSubscription={setSubscription}
    />
  );

  return { fields, toPayload };
}
